import StyledIcon from "../StyledIcon";

const WaVolumeOff = props => {
    return <StyledIcon width="31" height="21" viewBox="0 0 31 21" fill="none" {...props}>
        <path d="M13.0147 1.40723L6.60326 6.50723H1.49414V14.2072H6.60326L13.0147 19.3072V1.40723Z" strokeWidth="2" strokeLinejoin="round" />
        <path d="M29.5234 5.35742L19.5234 15.3574M19.5234 5.35742L29.5234 15.3574" strokeWidth="2" strokeLinejoin="round" />
    </StyledIcon>
}

export default WaVolumeOff;